(() => {
  const THRESHOLD = 3000000; // $30.000 (Shopify guarda CLP x100)
  const SELECTOR_UI = '[data-gt-cart-ui]';
  let timer = null;
  let inFlight = false;
  let queued = false;

  const formatClp = (value) => {
    const pesos = Math.max(0, Math.round(Number(value || 0) / 100));
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(pesos);
  };

  const cardMarkup = (cart, compact = false) => {
    const total = Number(cart.total_price || 0);
    const remaining = Math.max(0, THRESHOLD - total);
    const progress = Math.min(100, Math.max(0, (total / THRESHOLD) * 100));
    const complete = remaining <= 0;
    const cls = `gt-shipping-card${compact ? ' gt-shipping-card--drawer' : ''}${complete ? ' is-complete' : ''}`;
    const message = complete
      ? '¡Envío gratis en RM desbloqueado!'
      : `Te faltan <strong>${formatClp(remaining)}</strong> para envío gratis en RM`;
    const helper = complete
      ? 'Aplica si despachas a la Región Metropolitana. Regiones: tarifa según zona.'
      : 'Envío gratis solo para despachos en la Región Metropolitana.';

    return `
      <div class="${cls}" data-gt-cart-ui role="status" aria-live="polite">
        <div class="gt-shipping-card__top">
          <span class="gt-shipping-card__badge">ENVÍO GRATIS EN RM · DESDE ${formatClp(THRESHOLD)}</span>
          <span class="gt-shipping-card__message">${message}</span>
        </div>
        <div class="gt-progress" role="progressbar" aria-label="Progreso para envío gratis en RM" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}">
          <span class="gt-progress__fill" style="--gt-progress:${progress.toFixed(1)}%"></span>
        </div>
        <div class="gt-shipping-card__meta">
          <span>${helper}</span>
          <span class="gt-shipping-card__promo">2 bolsos = <strong>15% OFF</strong> en la segunda unidad</span>
        </div>
      </div>`;
  };

  const ensureProgress = (cart) => {
    const pageTitle = document.querySelector('cart-items .title-wrapper-with-link');
    let pageCard = document.getElementById('GtCartProgressPage');
    if (pageTitle && cart.item_count > 0) {
      if (!pageCard) {
        pageCard = document.createElement('div');
        pageCard.id = 'GtCartProgressPage';
        pageCard.setAttribute('data-gt-cart-ui', '');
        pageTitle.insertAdjacentElement('afterend', pageCard);
      }
      pageCard.innerHTML = cardMarkup(cart, false);
    } else if (pageCard) {
      pageCard.remove();
    }

    const drawer = document.querySelector('#CartDrawer');
    const drawerHeader = drawer?.querySelector('.drawer__header');
    let drawerCard = document.getElementById('GtCartProgressDrawer');
    if (drawer && drawerHeader && cart.item_count > 0 && !drawer.closest('cart-drawer')?.classList.contains('is-empty')) {
      if (!drawerCard) {
        drawerCard = document.createElement('div');
        drawerCard.id = 'GtCartProgressDrawer';
        drawerCard.setAttribute('data-gt-cart-ui', '');
        drawerHeader.insertAdjacentElement('afterend', drawerCard);
      }
      drawerCard.innerHTML = cardMarkup(cart, true);
    } else if (drawerCard) {
      drawerCard.remove();
    }
  };

  const trustMarkup = () => `
    <div class="gt-cart-trust" data-gt-cart-ui aria-label="Beneficios de compra">
      <span><b>✓</b> Pago seguro</span>
      <span><b>✓</b> Envíos a todo Chile</span>
      <span><b>✓</b> Cambios y devoluciones hasta 30 días</span>
    </div>`;

  const readyMarkup = () => `
    <div class="gt-cart-ready" data-gt-cart-ui>
      <span class="gt-cart-ready__dot" aria-hidden="true"></span>
      <span>Todo listo para continuar</span>
    </div>`;

  const ensureSummary = (cart) => {
    const pageBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (pageBlocks && cart.item_count > 0) {
      if (!pageBlocks.querySelector('.gt-cart-summary-title')) {
        pageBlocks.insertAdjacentHTML('afterbegin', '<div class="gt-cart-summary-title" data-gt-cart-ui>Resumen de tu compra</div>');
      }
      const pageCtas = pageBlocks.querySelector('.cart__ctas');
      if (pageCtas && !pageBlocks.querySelector('.gt-cart-ready')) pageCtas.insertAdjacentHTML('beforebegin', readyMarkup());
      if (pageCtas && !pageBlocks.querySelector('.gt-cart-trust')) pageCtas.insertAdjacentHTML('afterend', trustMarkup());
    }

    const drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
    const drawerSummary = drawerFooter?.querySelector('.cart-drawer__footer');
    if (drawerFooter && drawerSummary && cart.item_count > 0) {
      if (!drawerSummary.querySelector('.gt-cart-summary-title')) {
        drawerSummary.insertAdjacentHTML('afterbegin', '<div class="gt-cart-summary-title" data-gt-cart-ui>Resumen de tu compra</div>');
      }
      const drawerCtas = drawerFooter.querySelector('.cart__ctas');
      if (drawerCtas && !drawerFooter.querySelector('.gt-cart-ready')) drawerCtas.insertAdjacentHTML('beforebegin', readyMarkup());
      if (drawerCtas && !drawerFooter.querySelector('.gt-cart-trust')) drawerCtas.insertAdjacentHTML('afterend', trustMarkup());
    }
  };

  const removeUiWhenEmpty = () => {
    document.querySelectorAll(SELECTOR_UI).forEach((node) => node.remove());
  };

  async function syncCartUi() {
    if (inFlight) { queued = true; return; }
    inFlight = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart.item_count) { removeUiWhenEmpty(); return; }
      ensureProgress(cart);
      ensureSummary(cart);
    } catch (error) {
      console.debug('GymTonic cart UX:', error);
    } finally {
      inFlight = false;
      if (queued) { queued = false; scheduleSync(120); }
    }
  }

  function scheduleSync(delay = 360) {
    clearTimeout(timer);
    timer = setTimeout(syncCartUi, delay);
  }

  const mutationIsRelevant = (mutation) => {
    const target = mutation.target?.nodeType === 1 ? mutation.target : mutation.target?.parentElement;
    if (!target) return false;
    if (target.closest?.(SELECTOR_UI) || target.closest?.('[data-gt-ups]')) return false;
    const added = [...(mutation.addedNodes || [])].filter((node) => node.nodeType === 1);
    const removed = [...(mutation.removedNodes || [])].filter((node) => node.nodeType === 1);
    if (added.length && !removed.length && added.every((node) => node.matches?.(`${SELECTOR_UI}, [data-gt-ups]`))) return false;
    if (target.closest?.('cart-items, cart-drawer, #main-cart-footer')) return true;
    return [...added, ...removed].some((node) =>
      node.matches?.('cart-items, cart-drawer, #main-cart-footer') ||
      node.querySelector?.('cart-items, cart-drawer, #main-cart-footer')
    );
  };

  const observer = new MutationObserver((mutations) => {
    if (mutations.some(mutationIsRelevant)) scheduleSync();
  });

  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    syncCartUi();
  };

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('input[name="updates[]"]')) scheduleSync(650);
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target?.closest?.('.quantity__button, cart-remove-button, .cart-remove-button')) scheduleSync(700);
  }, true);

  window.addEventListener('pageshow', () => scheduleSync(50));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();